import { useShallow } from 'zustand/react/shallow';
import { useStore } from '@/store/useStore';

export enum PLACEHOLDER_TYPE {
  NONE = 'none',
  INITIALIZING = 'initializing',
  LOADING = 'loading',
  LOCATION = 'location',
  FAILED = 'failed',
}

export const useDecidePlaceholderType = (
  isStuckedLoading: boolean,
  loadingAnimationFinished: boolean,
  isSessionReady?: boolean,
) => {
  const { loading: isCustomerDataLoading } = useStore(
    useShallow((s) => s.customerData),
  );
  const gameStatus = useStore(
    useShallow((s) => ({
      gameLoadSuccess: s.gameStatus.gameLoadSuccess,
      gameFetchFailed: s.gameStatus.gameFetchFailed,
      gameFetchStarted: s.gameStatus.gameFetchStarted,
      gameLoadStarted: s.gameStatus.gameLoadStarted,
    })),
  );
  const geolocationStatus = useStore(useShallow((s) => s.geolocationStatus));

  if (!isSessionReady || isCustomerDataLoading) {
    return 'initializing';
  }

  if (gameStatus.gameFetchFailed) {
    return PLACEHOLDER_TYPE.FAILED;
  }

  if (
    geolocationStatus.geolocationInProgress &&
    !(
      gameStatus.gameLoadSuccess ||
      gameStatus.gameFetchStarted ||
      gameStatus.gameLoadStarted ||
      isStuckedLoading
    ) &&
    !(
      geolocationStatus.geolocationSuccess ||
      geolocationStatus.geolocationRejected ||
      geolocationStatus.geolocationFailed
    )
  ) {
    return PLACEHOLDER_TYPE.LOCATION;
  }

  if (
    (gameStatus.gameLoadSuccess && loadingAnimationFinished) ||
    (isStuckedLoading && loadingAnimationFinished)
  ) {
    return PLACEHOLDER_TYPE.NONE;
  }
  if (gameStatus.gameLoadStarted || gameStatus.gameFetchStarted) {
    return PLACEHOLDER_TYPE.LOADING;
  }

  return PLACEHOLDER_TYPE.INITIALIZING;
};
